<template>
  <div class="qr-code">
      <b-img :src="qrImage" :alt="$t('advertiseWithUsAlt',{ site_name: $root.siteTitle})"/>
      <div style="width: 315px;text-align: center;">{{$t('qrCodeScanNote')}}</div>
      <b-button class="btn-payment" id="paidAlready" @click="paidAlready">{{$t('payment.already paid')}}</b-button>
  </div>
</template>
<script>
export default {
  name: "QrPopup",
  props: {
    qrImage:{
      type: String,
      required: true
    },
    orderId:{
      type: Number,
      required: true
    },
    previousPendingPaymentId:{
       required: false,
      default: null
    }
  },
  data() {
    return {
      
    };
  },
  methods: {
    paidAlready(){
       this.$router.push({
            name: "PaymentSuccess",
            params: { id: this.orderId, previousPendingPaymentId: this.previousPendingPaymentId }
          });
    }
  }
};
</script>
<style lang="scss" scoped>
.qr-code{
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: center;
}
.btn-payment {
  margin-top:10px;
  font-size: 16px;
  @media (max-width: 992px) {
    font-size: 18px;
  }
  width: 225px;
  background: var(--projectPrimaryColor) !important;
  color: $white!important;
  border-radius: var(--borderRadius);
  border: 1px solid var(--projectPrimaryColor) !important;
  height: 40px;
}
</style>